
import { defineComponent, Ref, ref, computed } from 'vue'
import VesselMonitoringSingleHatch from "./VesselMonitoringSingleHatch.vue"

export default defineComponent({
  components: {
    VesselMonitoringSingleHatch
  },
  props: {
    vesselHatch: {},
  },
  computed: {
    vesselMonitoringData() {
      return this.vesselHatch[0]
    }
  }
});

